var map = {
	"./assistant_left.png": 85,
	"./assistant_right.png": 3009,
	"./bg.jpg": 5917,
	"./bg1.jpg": 942,
	"./levels/1/data": 7571,
	"./levels/1/data.json": 7571,
	"./levels/1/data1.html": 5472,
	"./levels/1/data2.html": 4332,
	"./levels/1/friend1.png": 6073,
	"./levels/1/friend2.png": 4933,
	"./levels/1/friend3.png": 5797,
	"./levels/1/friends.png": 6351,
	"./levels/1/stranger1.png": 4510,
	"./levels/1/stranger2.png": 8871,
	"./levels/1/stranger3.png": 5011,
	"./levels/1/teacher.png": 5071,
	"./levels/1/video1.mp4": 5941,
	"./levels/2/data": 8970,
	"./levels/2/data.json": 8970,
	"./levels/2/imagegame1.jpg": 3976,
	"./levels/2/imagegame2.jpg": 9246,
	"./levels/2/imagegame3.jpg": 1957,
	"./levels/2/imagegame4.png": 762,
	"./levels/2/imagegame5.png": 8758,
	"./levels/2/netzwerk.gif": 7813,
	"./levels/2/report1.jpg": 6181,
	"./levels/2/report2.jpg": 7234,
	"./levels/2/report3.jpg": 9798,
	"./levels/2/video2.mp4": 5939,
	"./levels/3/craap.jpg": 8164,
	"./levels/3/data": 6917,
	"./levels/3/data.json": 6917,
	"./levels/3/internetsecurity.png": 5758,
	"./levels/3/video3.mp4": 2337,
	"./levels/3/video4.mp4": 9491,
	"./levels/levels": 4693,
	"./levels/levels.json": 4693,
	"./sounds/correct.wav": 3266,
	"./sounds/error.wav": 4345,
	"./sounds/lose.wav": 9697,
	"./sounds/stick.wav": 5076,
	"./sounds/win.mp3": 712,
	"./story/1.png": 1537,
	"./story/2.png": 1870,
	"./story/3.png": 6652,
	"./story/4.png": 1260,
	"./trophy.png": 7826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;